export default text =>
  /¤¤/g.test(text)
    ? {
        dangerouslySetInnerHTML: { __html: text.replace(/¤¤/g, '&shy;') }
      }
    : { children: text };
